export default __webpack_public_path__ + "static/media/01.6fa59f03.jpg";